"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.login = exports.setConfig = void 0;
let config = {
    appId: "",
    cookie: true,
    xfbml: true,
    version: "v4.0",
};
let loginPromise;
function getFbSdk() {
    if (!config.appId)
        throw new Error("Should call setConfig first with actual appId");
    if (loginPromise)
        return loginPromise;
    loginPromise = new Promise(resolve => {
        window.fbAsyncInit = function () {
            window.FB.init(config);
            resolve(window.FB);
        };
        (function (d, s, id) {
            const fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            const js = d.createElement(s);
            js.id = id;
            js.src = "//connect.facebook.net/en_US/sdk.js";
            fjs.parentNode && fjs.parentNode.insertBefore(js, fjs);
        })(document, "script", "facebook-jssdk");
    });
    return loginPromise;
}
function setConfig(current) {
    config = Object.assign(Object.assign({}, config), current);
}
exports.setConfig = setConfig;
function login() {
    return new Promise((resolve, reject) => {
        getFbSdk()
            .then(FB => FB.login(r => resolve(r), {
            scope: "email, public_profile",
        }))
            .catch(reject);
    });
}
exports.login = login;
//# sourceMappingURL=facebook.js.map